module.exports = __webpack_public_path__ + "img/gly_login.1fdca676.svg";